import { createAction } from '@ngrx/store';

export const notifyAlsoEnergyDown = createAction('[Sub System] Notify Also Energy down');
export const notifyAlsoEnergyUp = createAction('[Sub System] Notify Also Energy up');
